import { cn } from '@/lib/utils'

interface Props {
  className?: string
  /** Show the wordmark next to the icon (default true). */
  showWordmark?: boolean
}

/**
 * Ovation logo — an inline SVG so it scales cleanly and inherits currentColor.
 * The mark is an abstract proscenium arch (curtain framing a stage) suggesting
 * "the preparation is ours, the ovation is yours". Pure SVG, no asset deps.
 */
export function Logo({ className, showWordmark = true }: Props) {
  return (
    <div className={cn('flex items-center gap-3 text-ovation-ink', className)}>
      <svg
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-10 w-10"
        aria-hidden
      >
        <defs>
          <linearGradient id="ov-grad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#D4AF37" />
            <stop offset="100%" stopColor="#9C7A1A" />
          </linearGradient>
        </defs>
        {/* Outer arch (proscenium) */}
        <path
          d="M8 56 V28 C8 14 20 4 32 4 C44 4 56 14 56 28 V56 Z"
          stroke="currentColor"
          strokeWidth="2.5"
          fill="none"
        />
        {/* Inner curtain swag */}
        <path
          d="M14 56 V30 C14 19 22 11 32 11 C42 11 50 19 50 30 V56"
          stroke="url(#ov-grad)"
          strokeWidth="2"
          fill="none"
        />
        {/* Centre stage star */}
        <path
          d="M32 22 L34.2 28.6 L41 28.6 L35.4 32.7 L37.6 39.3 L32 35.2 L26.4 39.3 L28.6 32.7 L23 28.6 L29.8 28.6 Z"
          fill="url(#ov-grad)"
        />
        {/* Stage line */}
        <line
          x1="6"
          y1="56"
          x2="58"
          y2="56"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </svg>
      {showWordmark && (
        <div className="leading-none">
          <div className="font-display text-2xl tracking-tight">Ovation</div>
          <div className="mt-0.5 text-[10px] uppercase tracking-[0.18em] text-ovation-muted">
            Back office for live music
          </div>
        </div>
      )}
    </div>
  )
}
